export default __webpack_public_path__ + "static/media/04_photo.92f82953.jpg";